//import React from 'react'
import firebase from 'firebase';

export class GetOneService {
  
  getUserId = () => {
    return firebase.auth().currentUser;
  }

  getOneUser = (path, id) => {
    return firebase
    .database()
    .ref(`${path}/${id}`)
    .once('value')
    .then(snapshot => snapshot.val())
  }

  getOne = (resource, params) => {
    console.log('getOne', resource, params);

    return firebase
      .database()
      .ref(`${resource}/${params.id}`)
      .once('value')
      .then(snapshot => {
        const item = Object.assign({}, { id: params.id }, snapshot.val());

        if (resource === 'events') {
          item.isPlanned = !item.isCanceled;
          return { data: item };
        }

        if (resource === 'companies') {
          const getUsers = () =>
            firebase
              .database()
              .ref('users')
              .once('value')
              .then(snapshot => snapshot.val());

          const getMissions = () =>
            firebase
              .database()
              .ref('missions')
              .once('value')
              .then(snapshot => snapshot.val());

          return Promise.all([getUsers(), getMissions()]).then(
            ([users, missions]) => {
              let company = item;

              const objectToArrayWithId = values =>
                Object.entries(values).map(value =>
                  Object.assign({}, { id: value[0] }, value[1])
                );

              Object.assign(company, {
                users: objectToArrayWithId(users).filter(
                  user => user.companyId === company.id
                ),
                missions: objectToArrayWithId(missions)
              });

              return {
                data: company
              };
            }
          );
        }

        if (resource === 'users') {
          const getAdmins = () =>
            firebase
              .database()
              .ref('admins')
              .once('value')
              .then(snapshot => snapshot.val());

          return Promise.all([getAdmins()]).then(([admins]) => {
            let user = item;

            const objectToArrayWithId = values =>
              Object.entries(values).map(value =>
                Object.assign({}, { id: value[0] }, value[1])
              );

            let admin = objectToArrayWithId(admins).filter(admin => {
              return admin.id === user.id;
            });

            Object.assign(user, {
              role: admin && admin[0] ? admin[0].role : 'noAdmin'
            });

            return {
              data: user
            };
          });
        }

        return { data: item };
      });
  };
}



// WEBPACK FOOTER //
// ./src/services/GetOneService.js